import PropTypes from 'prop-types';
import styled from 'styled-components';
import breakpoints from '../breakpoints';
import sharedStyles from '../styles';

const Sidebar = styled.div`
  display: none;

  @media screen and (min-width: ${breakpoints.md}) {
    display: ${({ active }) => (active ? 'block' : 'none')};
    border-right: 1px solid ${({ theme }) => theme.colors.border};
    width: ${({ widthPercent }) => widthPercent}%;
    padding: ${sharedStyles.spacing['spacing-lg']};
  }

  h5 {
    margin: 0 0 10px;
  }
`;

Sidebar.propTypes = {
  widthPercent: PropTypes.number,
};

Sidebar.defaultProps = {
  widthPercent: 20,
};

export default Sidebar;
